module.exports = __webpack_public_path__ + "static/media/Technos_diagonales_04.dbeb5579.png";